export default __webpack_public_path__ + "media/images/features/saga/illustrations_left-55544551a7aab2d8a1ef6a6ee87730c8.png";